import comboComponent from "@/components/child/form/combo.vue";
import { Component } from "@/decorators";
import TipoServico from "@/models/enum/tipoServico";
import ServicoEntregaModel from "@/models/servicoEntregaModel";
import ServicoEntregaService from "@/services/servicoEntregaService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        comboComponent,
    },
})
export default class ServicoEntregaEditComponent extends EditComponentBase<ServicoEntregaModel> {
    tipoOptions: Array<Object> = [
        { text: "Aéreo", value: TipoServico.Aereo },
        { text: "Correios", value: TipoServico.Correios },
        { text: "Outros", value: TipoServico.Outros },
    ];

    private async beforeMount() {
        await this.setProps(new ServicoEntregaService(), "servico_entrega", new ServicoEntregaModel());
    }
}
